export interface BaseImagesAndMetadata {
  onChainMetadata?: {
    edition_number?: number;
    edition_total?: number;
    target_address?: string;
  };
  requestedXch?: number;
  requestedNft?: string;
}

export interface Metadata {
  name: string;
  description: string;
  attributes: { trait_type: string; value: string }[];
  series_number?: number;
  series_total?: number;
  sensitive_content?: boolean;
}

export interface LocalImagesAndMetadata extends BaseImagesAndMetadata {
  dataFile: File;
  metadata: Metadata;
}

export interface RemoteImagesAndMetadata extends BaseImagesAndMetadata {
  dataUris: string[];
  dataHash: string;
  metadataUris: string[];
  metadataHash: string;
}

export type ImagesAndMetadata = LocalImagesAndMetadata | RemoteImagesAndMetadata;

export const isLocalData = (data: ImagesAndMetadata): data is LocalImagesAndMetadata => 'metadata' in data;
export const isRemoteData = (data: ImagesAndMetadata): data is RemoteImagesAndMetadata => 'dataUris' in data;
